import React, { lazy, Suspense } from 'react';

const LazyReport = lazy(() => import('./Report'));

const ReportComponent = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; } | any) => (
  <Suspense fallback={null}>
    <LazyReport {...props} />
  </Suspense>
);

export default ReportComponent;
